<template>
  <div class="content">
    <component :is='activeTab'></component>
  </div>
</template>

<script>

import RiskReport from "./content/riskReport.vue";
import ManageReport from "./content/riskManage.vue";
import GlobalView from "./content/globalView.vue";
import EChartView from "./content/eChartView.vue";

export default {
  data() {
    return {
      activeTab: ' ',
      comList: [
        { label: '风险报表', value: 'RiskReport' },
        { label: '问题报表', value: 'ManageReport' },
        { label: '全局报表', value: 'GlobalView' },
        { label: 'echart报表', value: 'EChartView' },
        // { label: '问题报表', name: 'manageReport' },
      ],
      // activeName: 'second'
    }
  },
  computed: {
    // getComp() {
    //   // return 'EChartView'
    //   return this.activeTab
    // }
  },
  components: { RiskReport, ManageReport, GlobalView, EChartView },
  methods: {
    getComp() {

      const { comp } = this.$route.meta;
      return comp
    }

  },
  created() {
    this.activeTab = this.getComp();
  },
}
</script>

<style scoped></style>